import React, { Component, ErrorInfo, ReactNode } from 'react';

interface State {
    hasError: boolean;
    error: Error | null;
}

interface Props {
    children: ReactNode;
}

/**
 * 頂層 Error Boundary：接住切頁時的 render 錯誤與 lazy chunk 載入失敗，
 * 避免 PWA 在手機上出現整頁白屏（隨機發生常與 chunk 載入或 cache 有關）。
 */
export class AppErrorBoundary extends Component<Props, State> {
    state: State = { hasError: false, error: null };

    static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('[AppErrorBoundary]', error, errorInfo);
    }

    handleRetry = () => {
        this.setState({ hasError: false, error: null });
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '100vh',
                        padding: 24,
                        boxSizing: 'border-box',
                        background: 'var(--bg-page, #E8ECF2)',
                        fontFamily: "'Noto Sans TC', sans-serif",
                        textAlign: 'center',
                    }}
                >
                    <p style={{ marginBottom: 8, fontSize: 18, color: 'var(--text-primary, #1a1a1a)' }}>
                        出了點問題
                    </p>
                    <p style={{ marginBottom: 24, fontSize: 14, color: 'var(--text-muted, #666)' }}>
                        請點下方按鈕重新載入頁面
                    </p>
                    <button
                        type="button"
                        onClick={this.handleRetry}
                        style={{
                            padding: '12px 24px',
                            fontSize: 16,
                            fontWeight: 600,
                            color: '#fff',
                            background: 'var(--primary, #4A7CFE)',
                            border: 'none',
                            borderRadius: 8,
                            cursor: 'pointer',
                        }}
                    >
                        重新載入
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}
